"use strict";

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelfcareBillsService = void 0;
const Interfaces_1 = require("../Interfaces");
var SelfcareBillsService;
(function (SelfcareBillsService) {
  /**
   * @title YOL Service
   * @version 3.9.1
   * @license MIT
   * @baseUrl /selfcare-bills
   * @contact YOL Digital <digital-yol@sunrise.net>
   *
   * YOL SELFCARE BILLS MICROSERVICE [ 📜 View Changelog](/selfcare-bills/internal/release-note)
   */
  class Api {
    constructor(url, http) {
      this.public = {
        /**
        * No description
        *
        * @tags Public
        * @name GetOpenInvoices
        * @request GET:/selfcare-bills/open-invoices
        * @secure bearerAuth
        * @response `200` `OpenInvoicesResp` Ok
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR",
             }`
        */
        getOpenInvoices: (params = {}) => this.http.request("GET", `${this.url}/selfcare-bills/open-invoices`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags Public
        * @name Invoices
        * @request GET:/selfcare-bills/invoices
        * @secure bearerAuth
        * @response `200` `AccountInvoiceResp` Ok
        * @response `400` `{
        error: "ERR_INVALID_BILL_YEAR_RANGE",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR",
             }`
        */
        invoices: (query, params = {}) => this.http.request("GET", `${this.url}/selfcare-bills/invoices`, {
          params: query,
          ...params
        }),
        /**
        * No description
        *
        * @tags Public
        * @name GetUsageDetailsPdf
        * @request GET:/selfcare-bills/usage-details-pdf/{invoiceNumber}
        * @secure bearerAuth
        * @response `200` `UsageDetailsPdfResp` Ok
        * @response `403` `{
        error: "ERR_INVALID_BRANDKEY" | "ERR_INVALID_PLATFORM",
             }`
        * @response `404` `{
        error: "ERR_NO_BG_FOUND" | "ERR_PDF_DATA_UNAVAILABLE" | "ERR_ACCOUNT_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR" | "ERR_FROM_CRM" | "ERR_FROM_API",
             }`
        * @response `504` `{
        error: "ERR_API_TIMEOUT",
             }`
        */
        getUsageDetailsPdf: (invoiceNumber, params = {}) => this.http.request("GET", `${this.url}/selfcare-bills/usage-details-pdf/${invoiceNumber}`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags Public
        * @name InvoiceDetailsPdf
        * @request GET:/selfcare-bills/invoice-details-pdf/{invoiceNumber}
        * @secure bearerAuth
        * @response `200` `InvoiceDetailsPdfResp` Ok
        * @response `404` `{
        error: "ERR_INVOICE_NUMBER_NOT_FOUND" | "ERR_DOCUMENT_NOT_FOUND" | "ERR_NO_BG_FOUND" | "ERR_INVOICE_DETAILS_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR",
             }`
        * @response `504` `{
        error: "ERR_API_TIMEOUT",
             }`
        */
        invoiceDetailsPdf: (invoiceNumber, params = {}) => this.http.request("GET", `${this.url}/selfcare-bills/invoice-details-pdf/${invoiceNumber}`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags Public
        * @name PayInvoicesByQrCode
        * @request POST:/selfcare-bills/invoices/pay/qr-bill
        * @secure bearerAuth
        * @response `200` `PayQrBillResp` Ok
        * @response `400` `{
        error: "ERR_INVALID_INVOICE_STATUS" | "ERR_INVALID_TOTAL_AMOUNT",
             }`
        * @response `404` `{
        error: "ERR_INVOICES_NOT_FOUND" | "ERR_ACCOUNT_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR" | "ERR_FROM_API",
             }`
        */
        payInvoicesByQrCode: (data, params = {}) => this.http.request("POST", `${this.url}/selfcare-bills/invoices/pay/qr-bill`, {
          body: data,
          headers: {
            "Content-Type": Interfaces_1.ContentType.Json
          },
          ...params
        })
      };
      this.http = http;
      this.url = url;
    }
  }
  SelfcareBillsService.Api = Api;
})(SelfcareBillsService || (exports.SelfcareBillsService = SelfcareBillsService = {}));